<style lang="scss" scoped>
.data-export {
	&__radio {
		display: block;
		width: 100%;
		clear: both;
		margin: 10px 0 10px 0 !important;
	}
	&__select-class,
	&__select-group {
		margin-top: 10px;
	}
	&__footer {
		margin-top: 30px;
	}
}
</style>

<template lang="pug"> 
    .data-export
        el-form(label-position="top", label-width='150px', @submit.native.prevent="handleSubmit" :loading="isLoading")
            div(v-show="companies && companies.length > 1")
                el-form-item(prop="companyId", label="Which company report would you like to run?")
                    company-search(v-model="companyId", :school="school" @companiesFromSelection="companies = $event")
                hr
            div(v-if="companyId")
                el-form-item(prop="filterType", label="Do you want to filter the entries?")
                    el-radio-group(v-model='parameters.filter.key' size='small')
                        el-radio(label=undefined).data-export__radio Include all
                        el-radio(v-for="item in exportFilters" :label="item.key" :key="item.key").data-export__radio Filter by {{ item.key.replace("_id", "") }}
                    el-select.data-export__select-class(v-if="parameters.filter.key == 'class_id'" v-model="parameters.filter.value", placeholder="Select class", :loading="isLoading", :disabled="isLoading", filterable, clearable, multiple)
                        el-option(v-for="item in classes", :key="item.id", :label="item.name", :value="item.id")
                            span(style='float: left') {{ item.name }}
                            span(style='float: right; color: #8492a6; font-size: 13px') {{ item.code }}
                    el-select.data-export__select-class(v-if="parameters.filter.key == 'subject_id'" v-model="parameters.filter.value", placeholder="Select subject", :loading="isLoading", :disabled="isLoading", filterable, clearable, multiple)
                        el-option(v-for="item in subjects", :key="item.id", :label="item.name", :value="item.id")
                            span(style='float: left') {{ item.name }}
                            span(style='float: right; color: #8492a6; font-size: 13px') {{ item.code }}
                    el-select.data-export__select-group(v-if="parameters.filter.key == 'group_id'" v-model="parameters.filter.value", placeholder="Select group", :loading="isLoading", :disabled="isLoading", filterable, clearable, multiple)
                        el-option(v-for="item in filteredGroups", :key="item.id", :label="item.name", :value="item.id")
                            span(style='float: left') {{ item.name }}
                            span(style='float: right; color: #8492a6; font-size: 13px') {{ item.type }} {{ item.code }}
                hr
                el-form-item(prop="parameters.type", label="Which entries should be included?")
                    el-radio-group(v-model='parameters.type' size='small')
                        el-radio(label="all_entries").data-export__radio Valid and Invalid Results
                        el-radio(label="valid_results").data-export__radio Valid Results
                        el-radio(label="validation_report").data-export__radio Validation Error Report
                hr(v-if="DataExportMeta && DataExportMeta.versions.length")
                el-form-item(v-if="DataExportMeta && DataExportMeta.versions.length", prop="parameters.version", label="Which report version?")
                    el-select.data-export__select-class(v-model="parameters.version", placeholder="Select version", :loading="isLoading", :disabled="isLoading", filterable clearable)
                        el-option(v-for="version in DataExportMeta.versions", :key="version.key", :label="version.title", :value="version.key")
                hr(v-if="DataExportMeta && DataExportMeta.identifiers && DataExportMeta.identifiers.length && loadIdentifiers")
                el-form-item(v-if="DataExportMeta && DataExportMeta.identifiers && DataExportMeta.identifiers.length && loadIdentifiers", prop="parameters.identifier", label="Select Identifier")
                    el-select.data-export__select-class(v-model="parameters.identifier", placeholder="Select identifier", :loading="isLoading", :disabled="isLoading", filterable clearable)
                        el-option(v-for="identifier in DataExportMeta.identifiers", :key="identifier.key", :label="identifier.title", :value="identifier.key")
            .data-export__footer
                el-button(@click="$vuedals.close(false)") Cancel
                el-button(type="primary", native-type="submit", :loading="isLoading" :disabled="isLoading || isDisabled") Download
</template>

<script>
import gql from "graphql-tag";
import { downloadCSV, paginateQuery } from "@/utils/dataExport.js";

export default {
	name: "DataExportModal",
	props: {
		school: {
			type: Object,
			required: true
		}
	},
	mounted() {
		this.watchParameters();

		this.cacheKey = `dataExport-${this.school.id}`;
	},
	data: () => ({
		page: 1,
		groups: [],
		classes: [],
		subjects: [],
		companies: [],
		loading: false,
		companyId: null,
		cacheKey: undefined,
		parameters: {
			filter: {
				key: undefined,
				value: []
			},
			type: "all_entries",
			version: null,
			identifier: null
		},
		DataExportMeta: {
			filters: [],
			versions: [],
			identifiers: [],
			customFilters: []
		},
		loadIdentifiers: false,
		error: null
	}),
	computed: {
		isLoading() {
			return this.$apollo.loading || this.loading;
		},
		isDisabled() {
			if (this.parameters.filter.key && !this.parameters.filter.value.length) return true;

			return this.companyId == null || this.parameters.type == null || this.error;
		},
		exportFilters() {
			if (this.DataExportMeta != undefined && this.DataExportMeta.customFilters && this.parameters.version) {
				const customFilters = this.DataExportMeta.customFilters.filter(item => item.version == this.parameters.version);
				if (customFilters.length) {
					return customFilters;
				}
			}

			return this.DataExportMeta.filters;
		},
		filteredGroups() {
			const groupFilter = this.exportFilters.find(item => item.key == 'group_id');

			if (groupFilter && typeof groupFilter.types != "undefined") {
				const groupTypes = groupFilter.types.split(",");
				return this.groups.filter(item => {
					return groupTypes.includes(item.type);
				});
			}

			return this.groups;
		}
	},
	watch: {
		"parameters.filter.key": {
			handler() {
				this.parameters.filter.value = [];
			}
		},
		"DataExportMeta": {
			handler(val) {
				if(val != undefined) {
					this.loadIdentifiers = val.versions && val.versions.length == 0
				}	
			}
		},
		"parameters.version": {
			handler(val) {
				const selectedVersion = this.DataExportMeta.versions.filter(version => version.key == val);
				
				this.loadIdentifiers = (this.DataExportMeta.versions.length && selectedVersion.length && selectedVersion[0].identifiers && selectedVersion[0].identifiers == true) 

				if (this.DataExportMeta.customFilters && this.DataExportMeta.customFilters.find(item => item.version == val)) {
					this.parameters.filter.value = [];
					this.parameters.filter.key = undefined;
				}
			}
		},
		companyId() {
			this.$apollo.queries.DataExportMeta.refetch();
		}
	},
	methods: {
		async handleSubmit() {
			this.loading = true;

			try {
				this.displayLoadingMessages();
				this.logDownload();
				const results = await paginateQuery(this.getData, true);

				if (!results.length) throw new Error("No results");

				await downloadCSV(this.school, results, this.parameters.version, this.companyId);
			} catch (err) {
				console.log("err.message", err.message);

				if (err.message.includes("DataExport:")) {
					this.$message.error(err.message.replace("GraphQL error: DataExport:", ""));
				} else if (err.message.includes("No results")) {
					this.$message.error("We could not find any results for this report");
				}
			}

			this.loading = false;
		},
		async getData(page) {
			const response = await this.$apollo.query({
				query: gql`
					query DataExport($companyId: String!, $schoolId: String!, $parameters: DataExportParameters, $page: Int) {
						DataExport(companyId: $companyId, schoolId: $schoolId, parameters: $parameters, page: $page)
					}
				`,
				variables: {
					page,
					schoolId: this.school.id,
					companyId: this.companyId,
					parameters: this.parameters
				},
				fetchPolicy: "no-cache"
			});

			return JSON.parse(response.data.DataExport);
		},
		displayLoadingMessages() {
			[{ seconds: 30, text: "Still processing..." }, { seconds: 60, text: "Number crunching..." }, { seconds: 90, text: "Nearly finished..." }].forEach(
				({ seconds, text }) => {
					setTimeout(() => {
						if (this.isLoading) {
							this.$message.info(text);
						}
					}, seconds * 1000);
				}
			);
		},
		watchParameters() {
			setInterval(() => {
				localStorage.setItem(
					this.cacheKey,
					JSON.stringify({
						parameters: this.parameters
					})
				);
			}, 5 * 1000);
		},
		loadParameters() {
			if (localStorage.getItem(this.cacheKey)) {
				const cachedParameters = JSON.parse(localStorage.getItem(this.cacheKey));
				this.$set(this, "parameters", cachedParameters.parameters);
			}
		},
		logDownload() {
			this.$apollo.mutate({
				mutation: gql`
					mutation CreateActivityLog($input: CreateActivityLogInput!) {
						CreateActivityLog(input: $input) {
							success
						}
					}
				`,
				variables: {
					input: {
						school_id: this.$route.params.school,
						company_id: this.companyId,
						version: this.parameters.version
					}
				}
			});
		}
	},
	apollo: {
		Classes: {
			query: gql`
				query Classes($school_id: ID) {
					Classes(school_id: $school_id) {
						id
						school_id
						name
						code
					}
					Groups(school_id: $school_id) {
						id
						school_id
						type
						name
						code
					}
					Subjects(school_id: $school_id) {
						id
						school_id
						name
						code
					}
				}
			`,
			variables() {
				return {
					school_id: this.school.id
				};
			},
			result(result) {
				this.classes = result.data.Classes;
				this.groups = result.data.Groups;
				this.subjects = result.data.Subjects;
				this.loadParameters();
			}
		},
		DataExportMeta: {
			query: gql`
				query DataExportMeta($schoolId: ID!, $companyId: ID!) {
					DataExportMeta(schoolId: $schoolId, companyId: $companyId) {
						versions {
							key
							title
							identifiers
						}
						filters {
							title
							key
						}
						identifiers {
							title
							key
						}
						customFilters {
							version
							title
							key
							types
						}
					}
				}
			`,
			variables() {
				return {
					schoolId: this.$route.params.school,
					companyId: this.companyId
				};
			},
			skip() {
				return !this.companyId;
			},
			result(r) {
				if (r.error != undefined && r.error.message) {
					this.error = true;
					return this.$message.error(r.error.message.replace("GraphQL error: ", ""));
				}				
				else if (r.data.DataExportMeta != undefined) {
					this.error = false;
					this.parameters.version = r.data.DataExportMeta.versions[0].key;
				}	

				return r;
			}
		}
	}
};
</script>
